import Vue from 'vue'
import router from './router'
import store from './store'
import dataV from "@jiaminghi/data-view";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import VueParticles from 'vue-particles'
import App from './App.vue'
Vue.config.productionTip = false
Vue.use(dataV);
Vue.use(ElementUI);
Vue.use(VueParticles);
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
